import { useQuery, UseQueryOptions, UseQueryResult } from 'react-query'
import { APIEndpoints } from '../constants/api-endpoints'
import { QueryKeys } from './_query_keys'
import { HttpRequest } from '../services/_http'

export type BufferLogsQueryParams = Record<string, unknown> | undefined

/** Row shape from `GET reports/dashboard/video-buffer` (list item). */
export type BufferLogRecord = {
  id: string
  device_id: string
  device_type: string
  episode_id: string
  user_id: number
  buffer: { start_time: number; end_time: number }[]
  createdAt: string
  updatedAt: string
}

export const useBufferLogs = (
  searchOptions?: BufferLogsQueryParams,
  options?: UseQueryOptions
): UseQueryResult<any> => {
  const method = 'GET'
  const queryKey = [QueryKeys.BUFFER_LOGS, searchOptions]

  return useQuery({
    queryKey,
    queryFn: () =>
      HttpRequest({
        url: `${APIEndpoints.VideoBufferReport}`,
        params: searchOptions,
        method,
      }),
    refetchOnWindowFocus: false,
    cacheTime: 0,
    ...options,
  })
}
